import * as Layouts from './individual'

export default Layouts
